import { render, staticRenderFns } from "./BjiOrderCommitResult.vue?vue&type=template&id=0df44f96&scoped=true&lang=pug"
import script from "./BjiOrderCommitResult.vue?vue&type=script&lang=js"
export * from "./BjiOrderCommitResult.vue?vue&type=script&lang=js"
import style0 from "./BjiOrderCommitResult.vue?vue&type=style&index=0&id=0df44f96&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df44f96",
  null
  
)

export default component.exports